<template>
    <loadArea v-if="model==null"></loadArea>
    <template  v-if="model!=null">
        <Form method="dialog" v-slot="{ errors }" class="floating-labels p-1rem align-items-start row" ref="form">
            <div class="col">
            <selectBox
                :title="'Hidden Approve Reasons'"
                :errors="errors"
                :rules="{}"
                @change="(e) => { const v = Number(e.target.value); if (model.includes(v)) model=model.filter(x=>x!=v); }"
            >
                <template #search>
                <input
                    type="text"
                    placeholder="Ara"
                    class="form-control small"
                    v-model="search.hidden"
                />
                </template>
                <template #input>
                <template v-for="item in Object.entries(reasons)">
                    <option
                    :value="Number(item[0])"
                    :key="item[0]"
                    v-if="
                            model.find(x=>x==item[0]) &&
                        item[1].toUpperCase().indexOf(
                            search.hidden.toUpperCase()
                        ) > -1
                    "
                    >{{ item[1] }}</option
                    >
                </template>
                </template>
            </selectBox>
            </div>
            <div class="col">
            <selectBox
                :title="'Show Approve Reasons'"
                :errors="errors"
                :rules="{}"
                @change="(e) => { const v = Number(e.target.value); if (!model.includes(v)) model.push(v); }"

            >
                <template #search>
                <input
                    type="text"
                    placeholder="Ara"
                    class="form-control small"
                    v-model="search.show"
                />
                </template>
                <template #input>
                <template v-for="item in Object.entries(reasons)">
                    <option
                    :value="Number(item[0])"
                    :key="item[0]"
                    v-if="
                            !model.find(x=>x==item[0]) &&
                        item[1].toUpperCase().indexOf(
                            search.show.toUpperCase()
                        ) > -1
                    "
                    
                    >{{ item[1] }}</option
                    >
                </template>
                </template>
            </selectBox>
            </div>
        </Form>
        <div class="modal-footer">
        <Btn
            class="btn-success btn-md"
            @click="save"
            :process="process"
            >Update Reasons</Btn
        >
        </div>
    </template>
</template>
<script>
import selectBox from "@/components/formGroup/selectBox";
export default
    {
        name: "approveReasons",
        components: { selectBox },
        props:{
            setModel:{
                type:Object,
                default:null    
            }
        },
        data() {
            return {
                search:{
                    hidden:"",
                    show:""
                },
                reasons: {
                    1: "Fiyat Uyuşmazlığı",
                    2: "Özel İndirim Talebi",
                    3: "Stoplu Tarih",
                    4: "Pax uyuşmazlığı",
                    5: "Özel misafir talebi",
                    6: "Özel acente talebi",
                    7: "Oda Tipi Uyuşmazlığı",
                    8: "Noshow'suz iptal",
                    9: "Satış tarihi değişikliği",
                    99: "Diğer"
                },
                model:null,
                process:false
            }
        },
        created(){
            this.$appAxiosAdmin.get(`Customers/${this.setModel.Id}/ApproveReasons`).then(response => {
                this.model=response.data;
            }).catch(err=>{
                this.$isError(err);
            });
        },
        methods:{
            save(){
                this.process=true;
                this.$appAxiosAdmin.put(`Customers/${this.setModel.Id}/ApproveReasons`,this.model).then(() => {
                    this.$swal({
                        icon: "success",
                        title: "Success",
                        text: "Updated approve reasons.",
                        confirmButtonText: "Okey",
                    });
                }).catch(err=>{
                    this.$isError(err);
                }).finally(()=>{
                    this.process=false;
                });
            }
        }
    }
</script>